/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @author Eugenij Tyan
 * @author Aleksandr Perkhunov
 * @version 1.3.1
 * @since 1.0.0
 */
import styled from 'styled-components';

import { colors } from '../../../../../../theme';

interface IFilterItemContainerProps {
    width: number;
    showBackground?: boolean;
}

export const ExtFilterConstructorContainerStyled = styled.div.attrs({
    'className': 'ext-filter__constructor-block',
    'data-extended-filter-constructor-block': 'extendedFilterConstructorBlock',
})`
    max-height: 300px;
    padding: 24px 24px 12px;
    background-color: ${colors.backgroundColorModal};
    overflow-y: auto;
`;

export const ExtFilterConstructorItemStyled = styled.div.attrs({
    className: 'ext-filter__constructor-item',
})`
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
    padding-bottom: 12px;
    outline: none;
    transition: .3s;
`;

export const ExtFilterItemContainerStyled = styled.div<IFilterItemContainerProps>`
    margin-right: 8px;
    background-color: ${colors.backgroundColorWhite};
    ${(props: { width: number }) => `
        width: ${props.width}px;
        flex: 0 1 ${props.width}px;
    `};
    & .constructor-item__value.value__input {
        color: ${colors.textColor};
        &.filled {
            border-color: ${colors.borderColorNormal};
        }
    }
`;

export const ExtFilterItemStubContainerStyled = styled.div.attrs({
    'className': 'ext-filter__constructor-item',
    'data-extended-filter-constructor-item': 'extendedFilterConstructorItem',
})<IFilterItemContainerProps>`
    height: 48px;
    margin-right: 8px;
    background-color: ${colors.backgroundColorWhite};
    ${(props: IFilterItemContainerProps) => `
        width: ${props.width}px;
        flex: 0 1 ${props.width}px;
    `};
    ${(props: IFilterItemContainerProps) =>
    props.showBackground
        ? `background-color: ${colors.backgroundColorDisabled};`
        : 'background-color: transparent;'
}
`;

export const AddContainerStyled = styled.div.attrs({
    'className': 'ext-filter__constructor-item constructor-item__add',
    'data-extended-filter-constructor-item-add': 'extendedFilterConstructorItemAdd',
    'tabIndex': 0,
})`
    height: 40px;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;

export const DeleteContainerStyled = styled.div.attrs({
    'className': 'ext-filter__constructor-item constructor-item__delete',
    'data-extended-filter-constructor-item-delete': 'extendedFilterConstructorItemDelete',
    'tabIndex': 0,
})`
    height: 40px;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 3px;
    margin-right: 16px;
    cursor: pointer;
`;
